// Яндекс.Метрика под Turbo.
//
// Раньше счётчик вставлялся в <body>, который Turbo заменяет при навигации, —
// после первого перехода он бы исчез. И хит отправлялся один раз за сессию,
// потому что DOMContentLoaded больше не наступает.

const COUNTER_ID = 104076007;

export function loadMetrika() {
  if (window.ym) return;

  window.ym =
    window.ym ||
    function () {
      (window.ym.a = window.ym.a || []).push(arguments);
    };
  window.ym.l = Date.now();

  const script = document.createElement("script");
  script.src = "https://mc.yandex.ru/metrika/tag.js";
  script.async = true;
  document.head.appendChild(script);

  window.ym(COUNTER_ID, "init", {
    // Первый хит отправляем сами — вместе со всеми последующими.
    defer: true,
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  });

  sendHit();
}

let referrer = document.referrer;

function sendHit() {
  if (!window.ym) return;
  window.ym(COUNTER_ID, "hit", location.href, {
    title: document.title,
    referer: referrer,
  });
  referrer = location.href;
}

/** Хит на каждую turbo-навигацию, а не только на первую загрузку. */
export function installMetrikaTracking() {
  document.addEventListener("turbo:load", sendHit);
}
